import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableHighlight,
  Image,
} from 'react-native';
import { BERRY } from '../../settings/colors';
import { isRowLayout } from '../../utilities/screen';
import { useHistory } from 'react-router-dom';
import Section from '../sections/Section';
import Logo from '../../assets/images/logo/logo-white-no-padding.png';
import Button from '../UI/Button';
import AppStore from '../../assets/images/app-store-badge.png';
import PlayStore from '../../assets/images/play-store-badge.png';
import learningLinks from './links/learn';
import companyLinks from './links/company';
import ideaLinks from './links/ideas';

const styles = StyleSheet.create({
  linkContainer: {
    marginRight: isRowLayout ? 50 : 0,
    marginTop: isRowLayout ? 0 : 20,
    flex: isRowLayout ? 1 : undefined,
  },
  bottomContainer: {
    marginTop: 50,
    flexDirection: isRowLayout ? 'row' : 'column',
    flex: 0,
    flexBasis: 'auto',
  },
  title: {
    fontWeight: 'bold',
    color: 'white',
    fontSize: 'large',
    opacity: 0.5,
    marginBottom: 10,
  },
});

function Footer() {
  const history = useHistory();
  return (
    <Section backgroundColor={BERRY}>
      <View
        style={{
          flexDirection: isRowLayout ? 'row' : 'column',
        }}
      >
        <View style={styles.linkContainer}>
          <TouchableHighlight onPress={() => history.push('/')}>
            <View>
              <img
                src={Logo}
                alt={'Triff'}
                style={{ width: '150px', marginBottom: '40px' }}
                resizemode="contain"
              />
            </View>
          </TouchableHighlight>
          <View style={[styles.badgeContainer, { marginBottom: 10 }]}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://itunes.apple.com/app/triff/id1447750499"
            >
              <img
                src={AppStore}
                style={{ width: '150px' }}
                alt={'Triff im App Store herunterladen'}
              />
            </a>
          </View>
          <View style={styles.badgeContainer}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://play.google.com/store/apps/details?id=com.triff"
            >
              <img
                src={PlayStore}
                style={{ width: '150px' }}
                alt={'Triff im Play Store herunterladen'}
              />
            </a>
          </View>
          <View style={{ marginVertical: 10 }}>
            <a href={'https://www.triff.app/download'}>
              <Text style={{ color: 'white' }}>Triff-App herunterladen</Text>
            </a>
          </View>
        </View>
        <View style={styles.linkContainer}>
          <Text style={styles.title}>Lernen</Text>
          {learningLinks.map(link => (
            <Button
              plain
              key={link.label}
              action={() => history.push(link.href)}
              text={link.label}
            />
          ))}
        </View>
        <View style={styles.linkContainer}>
          <Text style={styles.title}>Unternehmen</Text>
          {companyLinks.map(link => (
            <Button
              plain
              key={link.label}
              action={() => history.push(link.href)}
              text={link.label}
            />
          ))}
        </View>
        <View style={styles.linkContainer}>
          <Text style={styles.title}>Ideen</Text>
          {ideaLinks.map(link => (
            <Button
              plain
              key={link.label}
              action={() => history.push(link.href)}
              text={link.label}
            />
          ))}
        </View>
      </View>
      <View style={styles.bottomContainer}>
        <Text style={[styles.title, { fontSize: 'small' }]}>
          {`© ${new Date().getFullYear()} Ganz digital GmbH. Alle Rechte vorbehalten.`}
        </Text>
      </View>
    </Section>
  );
}

export default Footer;
